import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ln-realidad-aumentada-svg-icon',
  imports: [NgClass],
  templateUrl: './ln-realidad-aumentada-svg-icon.component.html',
  styleUrl: './ln-realidad-aumentada-svg-icon.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LnRealidadAumentadaSvgIconComponent {
  @Input({ required: true }) class!: string;
  @Input() fillColor = '#577778';
}
